import type { FormatKind } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';

// FIN-011 — GET /api/finance/formats?stateCode=XX returns the registered
// `FormatKind[]` for a state. Empty array means no builder is registered
// yet (e.g. AL pre-FIN-009). Used by the filings format picker, which is
// omitted from the DOM when length <= 1.

export const useFinanceFormats = defineQuery({
  key: (stateCode: string) => ['finance', 'formats', stateCode],
  reads: 'GET /api/finance/formats',
  staleTime: 60_000,
  fetch: (stateCode, { campaignId }): Promise<FormatKind[]> =>
    apiJson<FormatKind[]>(`/api/finance/formats?stateCode=${encodeURIComponent(stateCode)}`, {
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch supported formats',
    }),
});
